import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import { Tag } from '@tencent/wphk-design';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { HelpIcon, ArrowRightIcon, RefundOIcon } from '@tencent/wphk-icon-vue';
import { i18n } from '@/i18n';
import { useLocationStore } from '@/store/location';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { currentArea } = storeToRefs(useLocationStore());

const TAX_REFUND_APPID = 'wx20db1c50de53037b';
const DECOR_IMG_URL = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20260304142902/Ip_img-tiny.png';

const refundJumpInfo = {
  appid: TAX_REFUND_APPID,
  path: 'pages/home/index',
};

const guideJumpInfo = {
  appid: TAX_REFUND_APPID,
  path: 'pages/home/index?page=guide',
};

return { __sfc: true,currentArea, TAX_REFUND_APPID, DECOR_IMG_URL, refundJumpInfo, guideJumpInfo, Tag, MultiJumpContainer, HelpIcon, ArrowRightIcon, RefundOIcon, i18n }
}

})